// extracted by mini-css-extract-plugin
export default {"title":"Result-module__title--rjnol","text":"Result-module__text--gDbL8","subtitle":"Result-module__subtitle--qCupT","img":"Result-module__img--_dLmt"};